export default "<app-detail [title] = \"title\" [cardType] = \"cardType\" [buttonType] = \"buttonType\" [cards] = \"apiTransformers\" ></app-detail>\n"